import { ArgumentError } from '../utils/errors';

import { BaseAPIModel } from '@weezevent/weezjs-core';

export default class SeatSwapRequest extends BaseAPIModel {
    fields() {
        return {
            uuid: { readOnly: true, primaryKey: true }
        };
    }

    toSeatlib() {
        return {
            id: this.pk,
            name: this.name,
            price: this.price || 0
        };
    }

    confirm({ organization, event, change_barcode, send_email }) {
        let special_patch = this.copy();
        special_patch.confirm = true;
        special_patch.change_barcode = change_barcode;
        special_patch.send_email = send_email;

        // Delete unnecessary info that might block confirmation
        delete special_patch.destination_seats;
        delete special_patch.attendees;
        delete special_patch.zone;

        return special_patch.save({ organization, event });
    }

    static automatic({ organization, event, zone, attendees }) {
        let attendeesIds = attendees.map(attendee => attendee.pk);

        let body = {
            attendees: attendeesIds,
            zone: zone.uuid
        };

        return this.perform_request(body, { organization, event });
    }

    static manual({ organization, event, attendeesMap, useNew = false }) {
        let body = {};
        if (useNew) {
            body = attendeesMap
                .filter(attendee => attendee.new_seat)
                .reduce(
                    (acc, obj) => {
                        acc.attendees.push(obj.attendee.id);
                        acc.destination_seats.push(obj.new_seat.uuid);
                        return acc;
                    },
                    { attendees: [], destination_seats: [] }
                );
        } else {
            //@Todo:to be removed as soon as the new GDP is in use
            body = Object.values(attendeesMap).reduce(
                (acc, obj) => {
                    acc.attendees.push(obj.attendee);
                    acc.destination_seats.push(obj.newSeat.uuid);
                    return acc;
                },
                { attendees: [], destination_seats: [] }
            );
        }

        return this.perform_request(body, { organization, event });
    }

    static perform_request(body, { organization, event }) {
        let swap_request = new SeatSwapRequest(body);
        return swap_request
            .save({
                organization,
                event
            })
            .then(({ response }) => {
                // apply id to be able to patch later
                swap_request.uuid = response.uuid;
                return { swap_request, response };
            });
    }

    static listUrl({ organization, event }) {
        if (!organization || !event) {
            throw new ArgumentError(`[Model][SeatSwapRequest][getAll] organization and event are mandatory`);
        }

        return `/ticket/organizations/${organization.id}/events/${event.id}/seat_swap_request`;
    }
}
